const boldedElements = [
  `<b>PRO: CSE</b>`,
  `<b>PRO: CSE + TSXV</b>`,
  `<b>PRO: CSE + TSXV + TSX</b>`,
];

const link = [`<a href="https://ceo.ca/about/market-depth">here</a>`, `<a href="https://payments.ceo.ca/">here</a>`];

const billingInformationArray = [
  {
    id: 1,
    title: "How does billing work?",
    content:
      "CEO.CA is billed monthly on the anniversary of the date of your first payment. If you first paid on January 10, 2022, then your next billing dates are February 10, March 10, April 10, etc.",
  },
  {
    id: 2,
    title: "What is the cancellation policy for CEO Pro?",
    content:
      "You can cancel at any time, effective at the end of the billing period. There are no refunds or credits for partial months or years, unless required by law.",
  },
  {
    id: 3,
    title: "CEO PRO Plans and pricing",
    content:
      "There are three CEO PRO packages available, providing enhanced market data for three major Canadian exchanges.",
    secondaryContent: [
      {
        content: `The CEO.CA ${boldedElements[0]} plan for $50/month includes real-time CSE level 2 market depth. The CSE or Canadian Securities Exchange mainly includes small-cap and microcap companies, and at a level 2 market depth you can see all the bids and offers at other prices.plan is priced at $50/month, and includes real-time CSE level 2 market depth. The CSE (Canadian Securities Exchange) mainly includes small-cap and microcap companies; with level 2 market depth you can see all the bids and offers at other prices.`,
      },
      {
        content: `The CEO.CA ${boldedElements[1]} plan is priced at $80/month, which includes real-time CSE and TSX venture level 2 market depth. TSXV (Toronto Venture Stock Exchange) mainly focuses on early-stage companies and venture capital.`,
      },
      {
        content: `The CEO.CA ${boldedElements[2]} plan is priced at $116/month, which includes real-time CSE, TSX Venture, and TSX level 2 market depth. The TSX is the largest exchange in Canada and includes most of the major public companies in Canada.`,
      },
      {
        content: `CEO PRO can be purchased when you sign up for a new account; existing users can sign up ${link[0]}.`,
      },
    ],
  },
  {
    id: 4,
    title: "Updating Payment Information",
    content: `Your subscription and payment method can be changed ${link[1]}.`
  }
];

export default billingInformationArray;
